var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("A:/dev/workspace-node/bitbucket_repository/projects/widget-schedules-school-v3/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["../../@mecatran/components5/table/src/table.template.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "\r\n\r\n<table class=\"log\">\r\n";
output += "\r\n\r\n    <tbody>\r\n        ";
frame = frame.push();
var t_3 = (lineno = 16, colno = 39, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataTable")),"getRows"), "dataTable[\"getRows\"]", context, []));
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("row", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n        ";
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("rown", t_5, true);
if(frame.topLevel) {
context.setVariable("rown", t_5);
}
if(frame.topLevel) {
context.addExport("rown", t_5);
}
output += "\r\n        <tr>\r\n            ";
frame = frame.push();
var t_8 = (lineno = 19, colno = 39, runtime.callWrap(runtime.memberLookup((t_4),"getCells"), "row[\"getCells\"]", context, []));
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("cell", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
output += "\r\n                ";
var t_10;
t_10 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("celln", t_10, true);
if(frame.topLevel) {
context.setVariable("celln", t_10);
}
if(frame.topLevel) {
context.addExport("celln", t_10);
}
output += "\r\n                <td  class=\"";
output += runtime.suppressValue((lineno = 21, colno = 46, runtime.callWrap(runtime.memberLookup((t_9),"getClasses"), "cell[\"getClasses\"]", context, [])), env.opts.autoescape);
output += "\" colspan=";
output += runtime.suppressValue((lineno = 21, colno = 76, runtime.callWrap(runtime.memberLookup((t_9),"getSpan"), "cell[\"getSpan\"]", context, [])), env.opts.autoescape);
output += "  >";
output += runtime.suppressValue((lineno = 21, colno = 98, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "printString"), "printString", context, [(lineno = 21, colno = 120, runtime.callWrap(runtime.memberLookup((t_9),"getContentAsHtml"), "cell[\"getContentAsHtml\"]", context, []))])), env.opts.autoescape);
output += "</td>\r\n            ";
;
}
}
frame = frame.pop();
output += "\r\n        </tr>\r\n        ";
;
}
}
frame = frame.pop();
output += "\r\n    </tbody>\r\n\r\n</table>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["../../@mecatran/components5/table/src/table.template.njk"] , dependencies)